module.exports = __webpack_public_path__ + "img/pandarena-f-90.5fb6170a.gif";